import { useEffect, useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { exitHubModeAndGo, getActingHubId, getActingHubName } from '../../utils/actingHub';

export default function ActingHubBanner() {
  const [, setTick] = useState(0);

  useEffect(() => {
    const refresh = () => setTick((n) => n + 1);
    window.addEventListener('acting-hub-changed', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('acting-hub-changed', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const hubId = getActingHubId();
  if (!hubId) return null;

  return (
    <Alert
      severity="info"
      sx={{ borderRadius: 0, py: 0.5 }}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <Button color="inherit" size="small" onClick={() => exitHubModeAndGo('/super-admin')}>
            Exit hub mode
          </Button>
        </Stack>
      }
    >
      <Typography variant="body2">
        Operating as hub: <strong>{getActingHubName() || `Hub #${hubId}`}</strong>
      </Typography>
    </Alert>
  );
}
